// extracted by mini-css-extract-plugin
module.exports = {"canvas":"CanvasDrawing-module__canvas___3LcpM","labels":"CanvasDrawing-module__labels___1Faxs","wrapper":"CanvasDrawing-module__wrapper___hSVNC"};